


















import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppBar from "@/commons/components/globalNavigation/AppBar.vue";
import NavigationDrawer from "@/commons/components/globalNavigation/NavigationDrawer.vue";
import NotificationBar from "@/commons/components/globalNavigation/NotificationBar.vue";
import * as notifyUtil from "@/commons/utils/notifyUtil";
// NOTE: this.$refs の型定義をする際に InstanceType<typeof XXX> でキャストする関係上定義
// TODO: 疎結合でなくなってしまうため何か良い方法を考える必要あり
import AdunitGroupEditView from "@/features/adunitGroup/adunitGroupEditView.vue";
import AnalyticsReportEditView from "@/features/analytics/analyticsReportEditView.vue";

export default Vue.extend({
  name: "App",
  components: {
    NavigationDrawer,
    AppBar,
    NotificationBar,
  },
  created() {
    document.title = this.tabTitle + " - AutoStream";
  },
  computed: {
    viewTitle(): string | TranslateResult {
      switch (this.$route.name) {
        case "Home":
          return this.$t("home.viewTitle");
        case "Analytics":
          return this.$t("analytics.viewTitle.analytics");
        case "NewReport":
          return this.$t("analytics.viewTitle.newReport");
        case "EditReport":
          return this.$t("analytics.viewTitle.editReport");
        case "AdunitGroup":
          return this.$t("adUnitGroup.viewTitle.adUnitGroup");
        case "AdunitGroupSetting":
          return this.$t("adUnitGroup.viewTitle.newAdUnitGroup");
        case "AdunitGroupEdit":
          return this.$t("adUnitGroup.viewTitle.editAdUnitGroup");
        case "CoreWebVitals":
          return this.$t("coreWebVitals.viewTitle");
        case "CwvDomains":
          return this.$t("coreWebVitals.cwvDomains.viewTitle");
        case "Wrapper":
          return this.$t("wrapper.viewTitle");
        case "Engagement":
          return this.$t("engagement.viewTitle");
        case "Layout":
          return this.$t("layout.viewTitle");
        case "IdManager":
          return this.$t("idManager.viewTitle");
        case "ReleaseNote":
          return this.$t("releaseNote.viewTitle");
        case "Help":
          return this.$t("helpCenter.viewTitle");
        case "Setting":
          return this.$t("settings.viewTitle");
        default:
          return "";
      }
    },
    tabTitle(): string | TranslateResult {
      switch (this.$route.name) {
        case "Login":
          return this.$t("login.tabTitle");
        case "Home":
          return this.$t("home.tabTitle");
        case "Analytics":
          return this.$t("analytics.tabTitle.analytics");
        case "NewReport":
          return this.$t("analytics.tabTitle.newReport");
        case "EditReport":
          return this.$t("analytics.tabTitle.editReport");
        case "AdunitGroup":
          return this.$t("adUnitGroup.tabTitle.adUnitGroup");
        case "AdunitGroupSetting":
          return this.$t("adUnitGroup.tabTitle.newAdUnitGroup");
        case "AdunitGroupEdit":
          return this.$t("adUnitGroup.tabTitle.editAdUnitGroup");
        case "CoreWebVitals":
          return this.$t("coreWebVitals.tabTitle");
        case "CwvDomains":
          return this.$t("coreWebVitals.cwvDomains.tabTitle");
        case "Wrapper":
          return this.$t("wrapper.tabTitle");
        case "Engagement":
          return this.$t("engagement.tabTitle");
        case "Layout":
          return this.$t("layout.tabTitle");
        case "IdManager":
          return this.$t("idManager.tabTitle");
        case "ReleaseNote":
          return this.$t("releaseNote.viewTitle");
        case "Help":
          return this.$t("helpCenter.tabTitle");
        case "Setting":
          return this.$t("settings.tabTitle");
        case "NotFound":
          return this.$t("notFound.tabTitle");
        case "UnAuthorized":
          return this.$t("unAuthorized.tabTitle");
        default:
          return "";
      }
    },
  },
  watch: {
    $route() {
      document.title = this.tabTitle + " - AutoStream";
    },
  },
  methods: {
    verifyLogout() {
      if (
        this.$route.name === "NewReport" ||
        this.$route.name === "EditReport" ||
        this.$route.name === "AdunitGroupSetting" ||
        this.$route.name === "AdunitGroupEdit"
      ) {
        (
          this.$refs.view as InstanceType<
            typeof AdunitGroupEditView | typeof AnalyticsReportEditView
          >
        ).checkMove();
      } else {
        this.logout();
      }
    },
    logout() {
      this.$store
        .dispatch("auth/logout")
        .then(() => {
          // ログアウト成功時にセッショントークンを削除
          this.$cookies.remove("session");
          this.$router.push({ name: "Login" });
        })
        .catch(() => {
          notifyUtil.notifyErrorMessage(this.$t("general.notify.error.request.logout"));
        });
    },
  },
});
